import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcMinimizeFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.758 20v-2.994l-4.376 4.378a1.249 1.249 0 1 1-1.766-1.768L6.98 15.25H4.01a1.25 1.25 0 0 1 0-2.5h5.997c.69 0 1.25.56 1.25 1.25v6a1.25 1.25 0 1 1-2.5 0m10.86-17.384a1.248 1.248 0 1 1 1.766 1.768L17.02 8.75h2.97a1.25 1.25 0 0 1 0 2.5h-5.997c-.69 0-1.25-.56-1.25-1.25V4a1.25 1.25 0 1 1 2.5 0v2.994z"
  }));
}
var IcMinimizeFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcMinimizeFill));

export { IcMinimizeFill as I };
